module.exports = __webpack_public_path__ + "2-762cbc73.worker.js"